import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { formSubmission } from "../app/schema";

export const GET_FORM_SUBMISSIONS = "GET_FORM_SUBMISSIONS";
export const GET_FORM_SUBMISSION = "GET_FORM_SUBMISSION";
export const PATCH_FORM_SUBMISSIONS = "PATCH_FORM_SUBMISSIONS";
export const DELETE_FORM_SUBMISSION = "DELETE_FORM_SUBMISSION";

export const SET_IS_REMOVE_FORM_SUBMISSION_MODAL_VISIBLE = "SET_IS_REMOVE_FORM_SUBMISSION_MODAL_VISIBLE";
export const SET_IS_EDIT_FORM_SUBMISSION_MODAL_VISIBLE = "SET_IS_EDIT_FORM_SUBMISSION_MODAL_VISIBLE";

// Requests

const getFormSubmissionsGet = (fetch, apiHost, accessToken, meta) =>
  fetch(
    `${apiHost}/v1/form-submissions?limit=${meta.limit}&offset=${meta.currentPage *
      meta.limit}`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
      method: "GET"
    }
  ).then(response => {
    return validateResponse(response, {});
  });

const getFormSubmissionGet = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/form-submissions/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const patchFormSubmission = (fetch, apiHost, accessToken, uid, data) =>
  fetch(`${apiHost}/v1/form-submissions/${uid}`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {});
  });

const deleteFormSubmissions = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/form-submissions/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg: "Nie można usunąć danych kategorii, ponieważ są one używane przez inne zasoby.",
        field: "all"
      }
    });
  });

// Actions

export function getFormSubmissions(meta) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_FORM_SUBMISSIONS],
    payload: {
      promise: getFormSubmissionsGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        meta
      )
        .then(data => {
          data.formSubmissions.forEach(function(item, index) {
            item.content = JSON.parse(item.content).map(function(
              contentItem,
              contentIndex
            ) {
              return JSON.parse(contentItem);
            });
          });
          return normalize(data, { formSubmissions: arrayOf(formSubmission) });
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function getFormSubmission(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_FORM_SUBMISSION],
    payload: {
      promise: getFormSubmissionGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      )
        .then(data => {
          data.content = JSON.parse(data.content).map(function(item, index) {
            return JSON.parse(item);
          });
          return normalize(data, formSubmission);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function updateFormSubmission(data, uid) {
  data.content = JSON.stringify(data.content);
  return ({ fetch, validate, config, users, msg }) => ({
    type: [PATCH_FORM_SUBMISSIONS],
    payload: {
      promise: patchFormSubmission(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        data
      )
        .then(data => {
          return normalize(data, formSubmission);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removeFormSubmission(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [DELETE_FORM_SUBMISSION],
    payload: {
      promise: deleteFormSubmissions(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: {
        uid
      }
    }
  });
}

export function setIsRemoveFormSubmissionModalVisible(value) {
  return {
    type: SET_IS_REMOVE_FORM_SUBMISSION_MODAL_VISIBLE,
    data: {
      isVisble: value
    }
  };
}

export function setIsEditFormSubmissionModalVisible(value) {
  return {
    type: SET_IS_EDIT_FORM_SUBMISSION_MODAL_VISIBLE,
    data: {
      isVisble: value
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/formSubmissions/actions.js